import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetFilterCategorysSlice = createSlice({
    name: "getFilterCategory",
    initialState,
    reducers: {
        getFilterCategoryRequest(state) {
            state.loading = true;
        },
        getFilterCategoryRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getFilterCategoryRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getFilterCategoryRequest,
    getFilterCategoryRequestSuccess,
    getFilterCategoryRequestError,
} = GetFilterCategorysSlice.actions;

export default GetFilterCategorysSlice.reducer;
